import React, { ReactNode, createContext, useContext, useState } from 'react';



export interface InformationBarContextProps {
  displayComponent?: {
    Component?: Element,
    componentProps?: Record<string, unknown>,
    displayRoute?: string //route where to display top bar
  }; //this is the component that we want to display in the top info bar
  updateDisplayComponent?: ({
    Component,
    componentProps
  }: {
    Component?: Element,
    componentProps?: Record<string, unknown>
  }) => void;
}


const InformationBarContext = createContext<InformationBarContextProps>({
  displayComponent: undefined,
  updateDisplayComponent: () =>  console.log()
});


export const useInformationBar = () => useContext(InformationBarContext);


interface InformationBarProviderProps {
  bu?: string;
  children?: ReactNode[];
}


export const InformationBarProvider = ({ children }: InformationBarProviderProps): JSX.Element => {

  const [ displayComponent, setDisplayComponent ] = useState({
    Component: undefined,
    componentProps: undefined,
    displayRoute: undefined
  });

  const updateDisplayComponent = (Component: Element | undefined, componentProps: Record<string, unknown> | undefined, displayRoute: undefined | string) => {
    if(!Component) return 

    const state = {
      Component,
      componentProps,
      displayRoute
    }
    setDisplayComponent({...state})
  }
 
  return (
    <InformationBarContext.Provider value={{
        displayComponent,
        updateDisplayComponent
     }}>
      {children}
    </InformationBarContext.Provider>
  );
};